<template>
    <div>
        <v-toolbar flat color="primary" dark height="40" >
            <v-toolbar-title>
                <span>Quote Items</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="addNewItem" color="info" v-show="canAddDeleteItem">Add New Item</v-btn>
        </v-toolbar>
        <v-layout row wrap>
            <v-flex class="text-xs-center" v-show="canAddDeleteItem">
                <span>Fill Template Form: </span>
                <!-- <v-btn
                v-for = "templ in qteTemplates" 
                    :key="templ.id"
                    @click.prevent="onFillTemplate(templ.id)" small color="info"
                    >{{templ.name}}</v-btn> -->
                <v-btn
                    @click.prevent="onFillDmsConfigurator()" small color="info"
                    >DMS Configurator</v-btn>
                <!-- This feature is under redesign to integrate with new GShape.  -->
                <hr>
            </v-flex>
            <v-flex xs12>
                <v-alert
                :value="quoteData.basicInfo.totalAmountHasMultipleCurrencyError"
                type="error"
                >
                The Quote Items are using different currency. Please change it!
                </v-alert>

            </v-flex>
            <v-flex xs12>
                <v-alert
                :value="quoteData.basicInfo.totalAmountWrongCurrencyAlert"
                type="warning"
                >
                The quoted facility is foreign country, please consider if it is right to use Dollar as currency.
                </v-alert>

            </v-flex>

        </v-layout>

        <v-layout row wrap class="hidden-sm-and-up">
            <v-flex xs12 sm6 md4 px-1 v-for="item in quoteData.items" :key="item.id">
                <v-card>
                    <v-img
                    :src="item.ImgUrlW400"
                    aspect-ratio="2.00"
                    contain
                    >
                        <v-layout column fill-height class=" ">
                            <v-spacer></v-spacer>
                            <v-flex shrink pb-2>
                                <div class="headline primary lighten-5 text-xs-center">{{ item.catalogNum }}</div>
                                <!-- to custom item, allow upload image -->
                                <div class="text-xs-center" v-if="!item.itemId">
                                    <v-btn small color="info" @click="uploadItemImage(item)" >Upload Image</v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-img>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-layout row>
                            <v-flex xs-12 text-xs-center subheading>{{ item.description }}</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Qty:</v-flex>
                            <v-flex xs8 text-xs-left pt-1>{{ item.qty }}</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Unit:</v-flex>
                            <v-flex xs8 text-xs-left pt-1>{{ item.unit }}</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Unit Price:</v-flex>
                            <!-- <v-flex xs8 text-xs-left pt-1>{{ item.unitPrice  | toCurrency }}</v-flex> -->
                            <v-flex xs8 text-xs-left pt-1>{{ formatCurrency((!item.unitPrice? 0 : item.unitPrice), item.currnIdx) }}</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Price Level:</v-flex>
                            <v-flex xs8 text-xs-left pt-1>{{ item.unitPricePriceLevel }}</v-flex>
                        </v-layout>
                        <!-- <v-layout row>
                            <v-flex xs4 body-2 pt-1>Discount Per Unit:</v-flex>
                            <v-flex xs8 text-xs-left pt-1>{{ item.discountUnitAmt }}</v-flex>
                        </v-layout> -->
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Discount:</v-flex>
                            <v-flex xs8 text-xs-left pt-1>{{ getItemPromotionOrDiscountSummary(item) }}</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Total Price:</v-flex>
                            <!-- <v-flex xs8 text-xs-left pt-1>{{ item.totalPrice | toCurrency }}</v-flex> -->
                            <v-flex xs8 text-xs-left pt-1>{{ formatCurrency((!item.totalPrice? 0 : item.totalPrice), item.currnIdx) }}</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Internal Notes:</v-flex>
                            <v-flex xs8 text-xs-left pt-1>
                                <div>{{ item.notes }}</div>
                                <div v-if="item.systemNotes && !(item.unitPrice > 0)" class="caption error--text">
                                    {{ item.systemNotes }}
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn small color="primary"
                            v-show="canEditItem" @click="editItem(item)" >Edit</v-btn>
                        <v-btn small color="primary" v-show="canAddDeleteItem" 
                            @click="deleteItem(item)" >Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <ctlQuoteItemsInternalTableView 
            class="hidden-xs-only"
            :quoteData="quoteData" 
            @onEditItem="editItem"
            @onDeleteItem="deleteItem"
            @onMoveItem="moveItem"
            @onUploadItemImage="uploadItemImage"></ctlQuoteItemsInternalTableView>
        <v-dialog v-model="showItemEditPopup" width="500" height="400">
            <ctlQuoteItemEditInternal @onSaveItem="onSaveItem" :originalItemData="itemEditing"
                :facilityPriceLevel="quoteData.basicInfo.facilityPriceLevel"
                :hidePickPriceButton="quoteData.hidePickPriceButton"></ctlQuoteItemEditInternal>
        </v-dialog>
        <v-dialog v-model="showItemAddNewPopup" width="500" height="400">
            <ctlQuoteItemEdit @onSaveItem="onSaveItem" 
                @onReloadQuoteData="onReloadQuoteData"
                :originalItemData="itemEditing"
                :facilityPriceLevel="quoteData.basicInfo.facilityPriceLevel"></ctlQuoteItemEdit>
        </v-dialog>
        <v-dialog v-model="showItemUploadImagePopup" width="400" height="400" color="white">
            <ctlQuoteFileUpload 
                :quoteId="quoteData.id"
                :itemIdUploadImage="itemIdUploadImage"
                @fileUploaded="itemImageFileUploaded"
                @closeFileUpload="showItemUploadImagePopup = false" ></ctlQuoteFileUpload>
        </v-dialog>
        <v-dialog v-model="showTemplateForm" width="800"  hide-overlay >
            <ctlQuoteItemTemplateForm @onTemplateItemSaved="onSaveItem" 
                @onCloseItemTemplate="onCloseItemTemplate"
                :qteTempSearchParas="qteTempSearchParas"
                ></ctlQuoteItemTemplateForm>
        </v-dialog>
        <v-dialog v-model="showDmsConfigPopup" width="80%" >
            <ctlGetingeDmsConfigurator @onSaveItem="onSaveItem" :quoteId="quoteData.id"
                :facilityPriceLevel="quoteData.basicInfo.facilityPriceLevel"></ctlGetingeDmsConfigurator>
        </v-dialog>

    </div>
</template>
<script>
import ctlQuoteItemsInternalTableView from '@/components/ctlQuoteItemsInternalTableView'
import ctlQuoteItemEditInternal from '@/components/ctlQuoteItemEditInternal'
import ctlQuoteItemEdit from '@/components/public/ctlQuoteItemEdit'
import ctlQuoteFileUpload from "@/components/ctlQuoteFileUpload"
import ctlQuoteItemTemplateForm from "@/components/ctlQuoteItemTemplateForm"
import ctlGetingeDmsConfigurator from "@/components/ctlGetingeDmsConfigurator"
import { mapGetters, mapActions } from "vuex";

export default {
    props: ['quoteData'],
    components: {
        ctlQuoteItemsInternalTableView,
        ctlQuoteItemEditInternal,
        ctlQuoteItemEdit,
        ctlQuoteFileUpload: ctlQuoteFileUpload,
        ctlQuoteItemTemplateForm,
        ctlGetingeDmsConfigurator,
    },
    data() {
        return {
            showItemAddNewPopup: false,
            showItemEditPopup: false,
            itemEditing: null,
            showItemUploadImagePopup: false,
            itemIdUploadImage: null,
            showTemplateForm: false,
            showDmsConfigPopup: false,
            qteTempSearchParas: null,
            qteTemplates: [],
        }
    },
    computed: {
        ...mapGetters('auth', [
            'userHasInternalRole',
            'userHasSalesRepRole',
            'userHasSalesQuoteManagerRole',
        ]),
        quoteItemsActiveOnly () {
            return this.quoteData.items.filter(p=>p.active)
        },
        canEditItem () {
            return (this.userHasInternalRole || this.userHasSalesQuoteManagerRole) 
                && this.quoteData.basicInfo.statusId != 'SentToCustomer'
                && this.quoteData.basicInfo.statusId != 'Won'
                && this.quoteData.basicInfo.statusId != 'Lost'
        },
        canAddDeleteItem () {
            return this.quoteData.basicInfo.statusId != 'SentToCustomer'
                && this.quoteData.basicInfo.statusId != 'Won'
                && this.quoteData.basicInfo.statusId != 'Lost'
        },
    },
    methods: {
        ...mapActions('pubQuoteEdit', [
            'saveQuoteItem',
        ]),
        ...mapActions('adminQteTemplate', [
            'searchQuoteTemplates'
        ]),
        async getQteTemplates() {
            this.qteTemplates = await this.searchQuoteTemplates({
                templateId: null,
                active: true,
                status: 'published',
            })
        },
        uploadItemImage(item) {
            this.showItemUploadImagePopup = true
            this.itemIdUploadImage = item.id
        },
        itemImageFileUploaded(item) {
            this.showItemUploadImagePopup = false
            this.itemIdUploadImage = null
            this.$emit('reloadQuoteData')
        },
        addNewItem() {
            // to new item, populate init data here
            this.itemEditing = {
                quoteId: this.quoteData.id,
                id : null,
                itemId : null,
                itemNumber : null,
                description : null,
                qty : null,
                active : true,
                notes : null,
            }
            this.showItemAddNewPopup = true
        },
        onFillDmsConfigurator() {
            // to new item, populate init data here
            this.itemEditing = {
                quoteId: this.quoteData.id,
                id : null,
                itemId : null,
                itemNumber : null,
                description : null,
                qty : null,
                active : true,
                notes : null,
            }
            this.showDmsConfigPopup = true
        },
        editItem(item) {
            this.itemEditing = item
            this.showItemEditPopup = true
        },
        async deleteItem(item) {
            if(!confirm('Are you sure to delete this item?')) {
                return
            }
            if(item.id) {
                // existed item in db, set to inactive
                item.active = false
                await this.saveQuoteItem(item)

                //reload
                this.$emit('reloadQuoteData')
            } else {
                this.quoteData.items = this.quoteData.items.filter(p=> p != item)
            }
        },
        async moveItem(item, isMoveUp) {
            
            item.seqNo = isMoveUp? -999 : 999
            await this.saveQuoteItem(item)

            //reload
            this.$emit('reloadQuoteData')

        },
        onSaveItem(newOrExistedItem) {
            this.showItemAddNewPopup = false
            this.showItemEditPopup = false
            this.showDmsConfigPopup = false

            // if (newOrExistedItem) {
            //     // if(newOrExistedItem.id) {
            //     //     var existedItem = this.quoteData.items.find(o=>o.id === newOrExistedItem.id)
            //     //     existedItem = Object.assign({}, existedItem, newOrExistedItem)
            //     // }else {
            //     //     }
            //     var foundItem = this.quoteData.items.find(o=>o.itemNumber === newOrExistedItem.itemNumber)
            //     if (!foundItem) {
            //         this.quoteData.items = [...this.quoteData.items, newOrExistedItem]
            //     } else {
            //         foundItem = Object.assign({}, foundItem, newOrExistedItem)
            //     }
            // }
            this.$emit('reloadQuoteData')
        },
        onReloadQuoteData() {
            this.$emit('reloadQuoteData')
        },
        onFillTemplate(templateId) {
            this.qteTempSearchParas = {
                templateId: templateId,
                qteId: this.quoteData.id
            }
            this.showTemplateForm = true
        },
        onCloseItemTemplate() {
            this.qteTempSearchParas = null
            this.showTemplateForm = false
        },
        getItemPromotionOrDiscountSummary(itemData) {
            const promotion = itemData.promotionApplied
            if(!promotion) {
                return itemData.discountPct? ('(Discount: ' + itemData.discountPct + '%)') :''
            }
            
            //has promotion
            const maxQty = promotion.maxQty > 0 ? promotion.maxQty : "unlimited";
            if (promotion.promotionType === "DiscountPct") {
                return `(Promotion ${promotion.promotionCode}. Discount: ${promotion.promotionAmt}%)`;
            } else if (promotion.promotionType === "PromotionPrice") {
                return `(Promotion ${promotion.promotionCode}. Unit Price: $${promotion.promotionAmt})`;
            } else if (promotion.promotionType === "BuyXGetYFree"){
                return `(Promotion: Buy ${promotion.buyXGetYFreeBuyQty} Get ${promotion.buyXGetYFreeGetQty} Free)`;
            }
        },
    },
    created(){
        this.getQteTemplates()
    }
}
</script>
